import { useOutletContext } from 'react-router-dom'

import { TrainingSessionsByEmployeeDataTableQuery } from 'generated/resources/datatable.graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { UploadCertificate } from 'modules/trainings/components/MyTrainings/UploadCertificate'

type TrainingsSessionAccessMembership = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<TrainingSessionsByEmployeeDataTableQuery['trainings']>['sessionsConnection']
    >['edges'][0]
  >['node']
>
const EmployeeCertificatesUploadModal = () => {
  const { navigation } = useNavigation()
  const { employeeId, employeeAccessId, session } = useOutletContext<{
    employeeId: number
    employeeAccessId: number
    session: TrainingsSessionAccessMembership
  }>()
  return (
    <UploadCertificate
      navigateBackTo={navigation.employees.id.training.nextSession.fullPath({
        id: employeeId,
        sessionId: session.id,
      })}
      accessId={employeeAccessId}
    />
  )
}

export default EmployeeCertificatesUploadModal
